import { TOGGLE_SETTINGS, FILTER_SERVICE } from "./constants";

const initialState = {
  isSettingOpen: false,
  isFiltered: false,
  data: [
    {
      id: 0,
      value: 63,
      name: "زمن التقديم",
      detail: "3 دقائق",
      selected: true
    },
    {
      id: 1,
      value: 28,
      name: "زمن الانتظار",
      detail: "5 دقائق",
      selected: true
    },
    {
      id: 2,
      value: 84,
      name: "تكلفة الوحدة من الخدمة",
      detail: "2,500 درهم",
      selected: true
    },
    {
      id: 3,
      value: 24,
      name: "الانتاجية",
      detail: "24%",
      selected: true
    },
    {
      id: 4,
      value: 11,
      name: "مستوى الثقة ",
      detail: "11%",
      selected: true
    },
    {
      id: 5,
      value: 83,
      name: "مستوى رضا المتعاملين",
      detail: "83%",
      selected: true
    },
    {
      id: 6,
      value: 67,
      name: "زمن الخدمة القياسي",
      detail: "دقيقتين",
      selected: true
    },
    {
      id: 7,
      value: 95,
      detail: "95%",
      name: "استمرارية الخدمة",
      selected: true
    },
    {
      id: 8,
      detail: "18%",
      value: 18,
      name: "نسبة الإشغال",
      selected: true
    },
    {
      id: 9,
      value: 95,
      name: "القدرة الاستيعابية",
      detail: "95%",
      selected: true
    },
    {
      id: 10,
      value: 20,
      name: "معدل جودة الخدمة الكلي",
      detail: "5 دقائق",
      selected: true
    },
    {
      id: 11,
      value: 83,
      detail: "3 دقائق",
      name: "زمن اتمام الخدمة",
      selected: true
    }
  ],
  filteredData: [
    {
      id: 3,
      value: 24,
      name: "الانتاجية",
      selected: true
    },
    {
      id: 4,
      value: 11,
      name: "مستوى الثقة ",
      selected: true
    },
    {
      id: 5,
      value: 83,
      name: "مستوى رضا المتعاملين",
      selected: true
    },
    {
      id: 6,
      value: 67,
      name: "زمن الخدمة القياسي",
      selected: true
    },
    {
      id: 7,
      value: 95,
      name: "استمرارية الخدمة",
      selected: true
    }
  ]
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TOGGLE_SETTINGS:
      return {
        ...state,
        isSettingOpen: !state.isSettingOpen
      };
    case FILTER_SERVICE:
      return {
        ...state,
        isFiltered: true,
        filteredData: payload
      };

    default:
      return state;
  }
};
